import {alias, createModelSchema, list} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {AudienceModel} from "@/modules/maudiences/models/AudienceModel";

export class AudienceTestModel extends BaseObject {

    constructor() {
        super();
        this._id = "";
        this._name = "";
        this._audiences = [];
        this._users = 0;// 0 - all
        this._message = "";
    }

    get id() {return this._id;}
    set id(value) {this._id = value;}

    get name() {return this._name;}
    set name(value) {this._name = value;}

    get audiences() {return this._audiences;}
    set audiences(value) {this._audiences = value;}

    get users() {return this._users;}
    set users(value) {this._users = value;}

    get message() {return this._message;}
    set message(value) {this._message = value;}

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new AudienceTestModel());
        } else if (target instanceof AudienceTestModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(AudienceTestModel, {
    _id: alias("id", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _audiences: alias("audiences", list(AudienceModel.schema())),
    _users: alias("users", Schema.primitive()),
    _message: alias("message", Schema.primitive()),
});